import { ResultSet } from '@cubejs-client/core';

import { ChartRenderer } from 'components/Charts/ChartRenderer';

import { useDeepCompareMemo } from 'use-deep-compare';
import { PieChart } from 'bizcharts';
import { Chart, ChartCategory } from '../interfaces/Chart';

const PieChartRenderer = ({ resultSet }: { resultSet: ResultSet }) => {
  const [data, angleField] = useDeepCompareMemo(() => {
    return [resultSet.chartPivot(), resultSet.series()];
  }, [resultSet]);

  return (
    <PieChart
      data={data.map((item) => ({ ...item, x: item.x === '∅' ? 'Мобильное приложение' : item.x }))}
      radius={0.8}
      angleField={angleField[0]?.key || 'undefined'}
      colorField="x"
      label={{
        visible: true,
        offset: 20
      }}
      legend={{
        // offsetY: -30,
        visible: false,
        position: 'bottom'
      }}
    />
  );
};

export const ActiveSessionsByPlatform: Chart = {
  id: 'active_sessions_by_platform',
  name: 'Active Sessions by Platform',
  category: ChartCategory.SESSIONS,
  element: () => {
    return (
      <ChartRenderer
        width={320}
        height={400}
        chartProps={{
          id: 'active_sessions_by_platform',
          title: 'Сессии по платформам',
          query: {
            dimensions: ['Sessions.devicePlatform'],
            order: {
              'Sessions.createdat': 'asc'
            },
            measures: ['Sessions.count'],
            filters: [
              {
                member: 'Sessions.expiresAtTimestamp',
                operator: 'gt',
                values: [Date.now().toString()]
              }
            ]
          },
          pivotConfig: {
            x: ['Sessions.devicePlatform'],
            y: ['measures'],
            fillMissingDates: true,
            joinDateRange: false
          },
          element: PieChartRenderer
        }}
      />
    );
  }
};
